export default __webpack_public_path__ + "static/media/news (4).f4c28264.webp";